export default __webpack_public_path__ + "static/media/030-vending machine.7d5ff8a4.svg";